<h2 mat-dialog-title>Add Patron Error</h2>
<mat-dialog-content>
  <p>The following patron cannot place a hold:</p>
  <p>{{ name }}</p>
  <ul style="list-style-type: disc; padding-left: 20px">
    @for (message of messages; track message) {
      <li>{{ message }}</li>
    }
  </ul>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close type="button">OK</button>
</mat-dialog-actions>
